import React, { useState, useEffect } from 'react';
import SectionLabel from '../../../components/SectionLabel';
import { Grid, Icon } from 'semantic-ui-react';
import { EstateFormProps } from '../EstateForm';
import Toggle from '../../../components/Toggle';

interface PromotionCode {
  code: string;
  activationDate: string;
  desactivationDate: string | null;
}

interface PromotionalCardProps {
  iconName: string;
  title: string;
  subtitle: string;
  validity: string;
  code: string;
  isSelected: boolean;
  onToggle: (code: string, isSelected: boolean) => void;
}

const PromotionalCard = ({
  iconName,
  title,
  subtitle,
  validity,
  code,
  isSelected,
  onToggle
}: PromotionalCardProps) => {
  const handleInfoClick = () => {
    window.open(
      '/documents/REGULAMENTO – Campanha _Lado Bom com Vistoria, Ganha+_.pdf',
      '_blank'
    );
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        gap: '10px',
        alignItems: 'center',
        height: '80px',
        marginRight: '50px'
      }}
    >
      <Toggle checked={isSelected} onChange={() => onToggle(code, !isSelected)} />
      <div style={{ display: 'flex', color: '#59249B' }}>
        <Icon name={iconName as any} size="big" />
      </div>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <span style={{ fontWeight: 'bold' }}>{title}</span>
        <span>{subtitle}</span>
        <span>{validity}</span>
      </div>
      <div
        style={{ alignSelf: 'flex-start', color: '#2185D0', cursor: 'pointer' }}
        onClick={handleInfoClick}
      >
        <Icon name="info circle" />
      </div>
    </div>
  );
};

const makeJson = (code: string, aDate: string, dDate: string | null): PromotionCode => {
  return {
    code,
    activationDate: aDate,
    desactivationDate: dDate
  };
};

export const PromotionalSection = (props: EstateFormProps) => {
  const { errors, touched, handleInputChange, setFieldValue } = props;
  const [selectedPromotions, setSelectedPromotions] = useState<PromotionCode[]>([]);

  const promotionalCampaigns = [
    {
      iconName: 'shield',
      title: 'Campanha Ganha +',
      subtitle: 'Seguro Fiança',
      code: 'FIANCA',
      validity: 'Validade: 02/05/2025 à 02/06/2026'
    },
    {
      iconName: 'fire extinguisher',
      title: 'Campanha Ganha +',
      subtitle: 'Seguro Incêndio',
      code: 'INCENDIO',
      validity: 'Validade: 02/05/2025 à 02/06/2026'
    },
    {
      iconName: 'shopping cart',
      title: 'Campanha Ganha +',
      subtitle: 'Casadinha',
      code: 'CASADINHA',
      validity: 'Validade: 02/05/2025 à 02/06/2026'
    }
  ];

  const handleTogglePromotion = (code: string, isSelected: boolean) => {
    const now = new Date().toISOString();
    const promotionExists = selectedPromotions.some(promotion => promotion.code === code);

    const updatedPromotions = promotionExists
      ? selectedPromotions.map(promotion =>
          promotion.code === code
            ? makeJson(
                code,
                isSelected ? now : promotion.activationDate,
                isSelected ? null : now
              )
            : promotion
        )
      : [...selectedPromotions, makeJson(code, now, null)];
    console.log('Updated Promotions:', updatedPromotions);
    setSelectedPromotions(updatedPromotions);
    setFieldValue('selectedPromotions', updatedPromotions);
  };

  useEffect(() => {
    setFieldValue('selectedPromotions', selectedPromotions);
  }, []);

  return (
    <>
      <SectionLabel text="PROMOCIONAL" />

      <Grid.Row>
        {promotionalCampaigns.map((campaign, index) => (
          <PromotionalCard
            key={index}
            iconName={campaign.iconName}
            title={campaign.title}
            subtitle={campaign.subtitle}
            validity={campaign.validity}
            code={campaign.code}
            isSelected={
              !!selectedPromotions.find(
                (promotion: PromotionCode) =>
                  promotion.code === campaign.code &&
                  promotion.activationDate &&
                  promotion.desactivationDate === null
              )
            }
            onToggle={handleTogglePromotion}
          />
        ))}
      </Grid.Row>
    </>
  );
};
